module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content.scommunity.scomslide) ? _c('div', {
    staticClass: "home-contests home-sponsor-contests"
  }, [_c('div', {
    staticClass: "home-contests__header"
  }, [_c('div', {
    staticClass: "home-contests__header-col home-contests__header-right"
  }, [_vm._v(_vm._s(_vm.content.scommunity.heading))])]), _c('div', {
    directives: [{
      name: "sponsor-slider-directive",
      rawName: "v-sponsor-slider-directive"
    }],
    staticClass: "home-contests__slider"
  }, _vm._l((_vm.content.scommunity.scomslide), function(slide) {
    return _c('div', {
      staticClass: "home-contests__slide"
    }, [_c('div', {
      staticClass: "home-contests__subtitle"
    }, [_vm._v(_vm._s(slide.subtitle))]), _c('div', {
      staticClass: "home-contests__para"
    }, [_vm._v(_vm._s(slide.para))]), (slide.slidelink) ? _c('div', {
      staticClass: "home-contests__image"
    }, [_c('a', {
      staticClass: "footer-main__addy",
      attrs: {
        "title": slide.image.title,
        "href": slide.slidelink,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "title": slide.image.title,
        "src": slide.image.url,
        "alt": slide.image.alt
      }
    })])]) : _c('div', {
      staticClass: "home-contests__image"
    }, [_c('img', {
      attrs: {
        "title": slide.image.title,
        "src": slide.image.url,
        "alt": slide.image.alt
      }
    })])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb473830","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-sponsor-contests/custom-sponsor-contests.pug
// module id = 659
// module chunks = 1